<template>

  <input
    ref="input"
    type="file"
    :id="name"
    :name="name"
    @change="onChange"
  >

</template>

<script>
  export default {
    name: 'FormControlFile',

    props: {
      name: {
        type: String,
        required: true,
      },
    },

    data() {
      return {
        filled: false,
      };
    },

    watch: {
      filled(value) {
        this.$emit('filled', value);
      },
    },

    methods: {
      onChange() {
        console.log(this.$refs);
        const input = this.$refs.input;

        this.filled = input.files.length > 0;

        if (this.filled) {
          this.$emit('value', input.files);
        }
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/FormControlFile.vue